import { useState } from "react";
import { Menu, X } from "lucide-react";
import { CheckoutButton } from "@/components/CheckoutButton";
import { COMMUNITY_NAME } from "@/config";

const LINKS = [
  { href: "#como-funciona", label: "Cómo funciona" },
  { href: "#para-quien", label: "Para quién es" },
  { href: "#preguntas-frecuentes", label: "Preguntas frecuentes" },
];

export const NavBar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-[#22304D]/70 bg-[#0B1120]/85 backdrop-blur-md">
      <nav className="mx-auto flex h-[68px] max-w-[1100px] items-center justify-between px-5">
        <a
          href="#inicio"
          data-testid="nav-brand"
          className="font-[Fraunces] text-lg font-semibold tracking-tight text-[#F5F1EA]"
        >
          {COMMUNITY_NAME}
        </a>
        <div className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link${l.href.replace("#", "-")}`}
              className="text-sm font-medium text-[#9AA6BE] transition-colors hover:text-[#8B7CF6]"
            >
              {l.label}
            </a>
          ))}
          <CheckoutButton
            testId="nav-entrar-button"
            origen="navbar"
            className="!px-5 !py-2.5 !text-sm"
          >
            Entrar en la comunidad
          </CheckoutButton>
        </div>
        <button
          data-testid="nav-menu-toggle"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Cerrar menú" : "Abrir menú"}
          className="flex h-10 w-10 items-center justify-center rounded-full text-[#F5F1EA] lg:hidden"
        >
          {open ? (
            <X className="h-6 w-6" strokeWidth={1.5} />
          ) : (
            <Menu className="h-6 w-6" strokeWidth={1.5} />
          )}
        </button>
      </nav>
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="border-t border-[#22304D] bg-[#0B1120] px-5 pb-6 pt-2 lg:hidden"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block border-b border-[#22304D]/60 py-3.5 text-base font-medium text-[#F5F1EA]"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
